/**
 * 登录注册
 */
import Container from '@/containers';

const loginRoter = {
    path: '/login',
    component: Container,
    redirect: '/login/login',
    name: 'Login',
    meta: {
        title: '登录'
    },
    children: [
        {
            path: '/login/login',
            component: () => import('@/views/login/login'),
            name: 'login',
            meta: {
                title: '登录'
            }
        },
        {
            path: '/login/register',
            component: () => import('@/views/login/register'),
            name: 'register',
            meta: {
                title: '注册'
            }
        },
        {
            path: '/login/getcode',
            component: () => import('@/views/login/getcode'),
            name: 'getcode',
            meta: {
                title: '输入验证码'
            }
        },
        {
            path: '/login/addname',
            component: () => import('@/views/login/addname'),
            name: 'addname',
            meta: {
                title: '真实姓名'
            }
        },
        {
            path: '/login/findpass',
            component: () => import('@/views/login/findpass'),
            name: 'findpass',
            meta: {
                title: '找回密码'
            }
        }
    ]
};

export default loginRoter;